import nanoajax from 'nanoajax'

function ajaxPost(data, formId) {
	nanoajax.ajax(
		{
			url: `https://api.hsforms.com/submissions/v3/integration/submit/2880903/${formId}`,
			headers: {
				'Content-Type': 'application/json',
				'Access-Control-Allow-Origin': '*',
			},
			method: 'POST',
			body: JSON.stringify(data),
		},
		(code, responseText) => {
			if (code !== 200) {
				console.warn(`${responseText}`)
				return
			}
		}
	)
}

export default ajaxPost
